import axios from 'axios';
const API_BASE = "/api/aprv";
// 결재문서 생성 API
export const createDoc = async (payload, token) => {
  try {
    const res = await axios.post(API_BASE, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        // ✅ Content-Type은 자동으로 multipart/form-data로 설정되므로 명시하지 않음
      },
    });
    return res.data; // 생성된 문서 데이터 반환
  } catch (err) {
    console.error('결재문서 생성 실패:', err);
    throw err;
  }
};
// 결재문서 수정 API
export const updateDoc = async (aprvId, payload, token) => {
  try {
    const res = await axios.put(`${API_BASE}/${aprvId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data; // { message: '문서 및 서브폼 수정 완료' }
  } catch (err) {
    console.error('결재문서 수정 실패:', err);
    throw err;
  }
};

// 📑 첨부파일 추가
export const addDocFile = async (aprvId, file, token, formCode) => {
  try {
    const formData = new FormData();
    formData.append('files', file);       // ✅ key 이름을 'files'로 맞춤 (multer array)
    formData.append('form_code', formCode); // ✅ 필수 컬럼 form_code 전달

    const res = await axios.post(`${API_BASE}/${aprvId}/files`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        // Content-Type은 자동으로 multipart/form-data로 설정됨
      },
    });
    return res.data; // 저장된 파일 정보 반환
  } catch (err) {
    console.error('첨부파일 추가 실패:', err);
    throw err;
  }
};
// 📑 첨부파일 삭제
export const deleteDocFile = async (aprvId, fileId, token) => {
  try {
    const res = await axios.delete(`${API_BASE}/${aprvId}/files/${fileId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data; // { message: '첨부파일이 삭제되었습니다.' }
  } catch (err) {
    console.error('첨부파일 삭제 실패:', err);
    throw err;
  }
};


// 결재문서 목록 조회 API
export const getDocs = async (page = 1, limit = 10, search = '', docStatus = '', token, M_ComCode = '') => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    if (M_ComCode) {
      headers['x-com-code'] = M_ComCode;
    }

    const res = await axios.get(API_BASE, {
      params: { page, limit, search, doc_status: docStatus },
      headers,
    });
    return res.data; // { docs: [], total: number }
  } catch (err) {
    console.error('결재문서 조회 실패:', err);
    throw err;
  }
};
// ✅ 관리자용
export const getDocsByAdmin = async (page = 1, limit = 10, search = '', docStatus = '', token) => {
  try {
    const res = await axios.get(`${API_BASE}/admin`, {
      params: { page, limit, search, status: docStatus }, // 관리자용은 status 파라미터 사용
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data; // { docs: [], total: number }
  } catch (err) {
    console.error('관리자용 결재문서 조회 실패:', err);
    throw err;
  }
};

// 결재문서 단건 조회 API
export const getDocById = async (aprvId, token) => {
  try {
    const res = await axios.get(`${API_BASE}/${aprvId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data; // { doc, lines, opinions, files, auths, subForms }
  } catch (err) {
    console.error('결재문서 조회 실패:', err);
    throw err;
  }
};

// 결재선 추가 API (단건)
export const addApprovalLine = async (aprvId, linePayload, token) => {
  try {
    const res = await axios.post(`${API_BASE}/${aprvId}/lines`, linePayload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data; // 생성된 결재선 데이터 반환
  } catch (err) {
    console.error('결재선 추가 실패:', err);
    throw err;
  }
};

// 결재선 추가 API (전체)
export const addApprovalLines = async (aprvId, linesPayload, token) => {
  try {
    const res = await axios.post(`${API_BASE}/${aprvId}/lines`, linesPayload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data; // 생성된 결재선 데이터 배열 반환
  } catch (err) {
    console.error('결재선 추가 실패:', err);
    throw err;
  }
};

//  결재선 전체 조회 API (옵션)
export const getApprovalLines = async (aprvId, token) => {
  try {
    const res = await axios.get(`${API_BASE}/${aprvId}/lines`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data; // { lines: [] }
  } catch (err) {
    console.error('결재선 조회 실패:', err);
    throw err;
  }
};

// 결재 처리 API (승인/반려/찬성/반대)
export const processApprovalLine = async (aprvId, lineId, action, token) => {
  try {
    const res = await axios.put(
      `${API_BASE}/${aprvId}/lines/${lineId}/process`,
      { action }, // 서버에서 action 값으로 처리
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data; // { message: '결재 처리가 완료되었습니다.' }
  } catch (err) {
    console.error("결재 처리 실패:", err);
    throw err;
  }
};

// 결재선 단건 수정
export const updateApprovalLine = async (aprvId, lineId, lineDto, token) => {
  try {
    const res = await axios.put(
      `${API_BASE}/${aprvId}/lines/${lineId}`,
      lineDto,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error('결재선 수정 실패:', err);
    throw err;
  }
};

// 결재선 단건 삭제
export const deleteApprovalLine = async (aprvId, lineId, token) => {
  try {
    const res = await axios.delete(`${API_BASE}/${aprvId}/lines/${lineId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    console.error('결재선 삭제 실패:', err);
    throw err;
  }
};
// 결재선 변경
export const replaceApprovalLines = async (aprvId, prevLines, nextSelected, token) => {
  // 보호 대상: 이미 결재 완료자 + 현재 결재자
  const protectedIds = new Set(
    prevLines
      .filter(l => l.done_date || l.current_yn === 'y')
      .map(l => l.line_id)
  );

  //  normalizedNext: 첫 번째 라인이라도 이미 결재 완료자는 current_yn = 'n'
  const normalizedNext = nextSelected.map((line, i) => ({
    ...line,
    aprv_id: aprvId,
    line_no: i + 1,
    current_yn: (!line.done_date && i === 0) ? 'y' : 'n',
  }));

  const keyOf = (l) => `${l.user_id}-${l.line_type}`;

  const prevByKey = new Map(prevLines.map((l) => [keyOf(l), l]));
  const nextByKey = new Map(normalizedNext.map((l) => [keyOf(l), l]));

  // 삭제 대상: prev에 있었지만 next에 없는 키 (보호 대상 제외)
  const toDelete = prevLines.filter(
    (l) => !protectedIds.has(l.line_id) && !nextByKey.has(keyOf(l))
  );

  // 수정 대상: prev와 next에 모두 있는 키 (보호 대상 제외)
  const toUpdatePairs = normalizedNext
    .filter((n) => prevByKey.has(keyOf(n)))
    .map((n) => {
      const prev = prevByKey.get(keyOf(n));
      if (protectedIds.has(prev.line_id)) return null; // 보호 대상은 수정 불가
      return {
        lineId: prev.line_id,
        dto: {
          aprv_id: aprvId,
          line_no: n.line_no,
          line_type: n.line_type,
          user_id: n.user_id,
          user_name: n.user_name,
          user_position: n.user_position,
          user_dept_code: n.user_dept_code,
          user_dept_name: n.user_dept_name,
          current_yn: n.current_yn,
        },
      };
    })
    .filter(Boolean);

  //  추가 대상: next에만 있는 키
  const toAdd = normalizedNext.filter((n) => !prevByKey.has(keyOf(n)));

  try {
    // 삭제
    for (const l of toDelete) {
      await deleteApprovalLine(aprvId, l.line_id, token);
    }
    // 수정
    for (const pair of toUpdatePairs) {
      await updateApprovalLine(aprvId, pair.lineId, pair.dto, token);
    }
    // 추가
    if (toAdd.length > 0) {
      await addApprovalLines(aprvId, toAdd, token);
    }

    return { deleted: toDelete.length, updated: toUpdatePairs.length, added: toAdd.length };
  } catch (err) {
    console.error('결재선 교체 실패:', err);
    throw err;
  }
};

// ✅ 결재 의견 등록 API 
export const addDocOpinion = async (aprvId, opinionData, token) => {
  try {
    const res = await axios.post(
      `${API_BASE}/${aprvId}/opinions`,   // ✅ /api/aprv prefix 사용
      opinionData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// 📑 열람자 권한 추가
export const addDocAuth = async (aprvId, payload, token) => {
  try {
    const res = await axios.post(
      `${API_BASE}/${aprvId}/auth`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("addDocAuth 실패:", err);
    throw err;
  }
};

// 📑 열람자 권한 삭제
export const deleteDocAuth = async (aprvId, targetType, targetId, token) => {
  try {
    const res = await axios.delete(
      `${API_BASE}/${aprvId}/auth/${targetType}/${targetId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  } catch (err) {
    console.error("deleteDocAuth 실패:", err);
    throw err;
  }
};

// 📑 열람자 권한 교체
export const replaceDocAuths = async (aprvId, payload, token) => {
  const res = await axios.put(
    `${API_BASE}/${aprvId}/auths`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};

